interface SvgIconProp {
  color: string;
}

export const PointerSvg = ({ color }: SvgIconProp) => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.9543 19.5565L0.601625 2.37484C0.381618 1.50639 1.32675 0.809052 2.09164 1.27548L17.5438 10.6982C18.338 11.1825 18.0987 12.3937 17.18 12.5396L10.8026 13.5524C10.5035 13.5999 10.242 13.7804 10.0915 14.0432L6.79154 19.8077C6.34475 20.5882 5.17515 20.4282 4.9543 19.5565Z"
      stroke={color}
    />
    <path
      d="M30.2727 15.4545L27.8523 22H26.8295L24.4091 15.4545H25.5L27.3068 20.6705H27.375L29.1818 15.4545H30.2727Z"
      fill={color}
    />
  </svg>
);

export const RectSvg = ({ color }: SvgIconProp) => (
  <svg
    width="30"
    height="25"
    viewBox="0 0 30 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9205 22V15.4545H25.892V16.4432H25.9602C26.0795 16.1193 26.2955 15.8565 26.608 15.6548C26.9205 15.4531 27.2727 15.3523 27.6648 15.3523C27.7386 15.3523 27.831 15.3537 27.9418 15.3565C28.0526 15.3594 28.1364 15.3636 28.1932 15.3693V16.392C28.1591 16.3835 28.081 16.3707 27.9588 16.3537C27.8395 16.3338 27.7131 16.3239 27.5795 16.3239C27.2614 16.3239 26.9773 16.3906 26.7273 16.5241C26.4801 16.6548 26.2841 16.8366 26.1392 17.0696C25.9972 17.2997 25.9261 17.5625 25.9261 17.858V22H24.9205Z"
      fill={color}
    />
    <rect
      x="18.5116"
      y="0.5"
      width="18.6465"
      height="18.0117"
      rx="0.5"
      transform="rotate(90 18.5116 0.5)"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EllipseSvg = ({ color }: SvgIconProp) => (
  <svg
    width="30"
    height="24"
    viewBox="0 0 30 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5795 22.1364C24.9886 22.1364 24.4702 21.9957 24.0241 21.7145C23.581 21.4332 23.2344 21.0398 22.9844 20.5341C22.7372 20.0284 22.6136 19.4375 22.6136 18.7614C22.6136 18.0795 22.7372 17.4844 22.9844 16.9759C23.2344 16.4673 23.581 16.0724 24.0241 15.7912C24.4702 15.5099 24.9886 15.3693 25.5795 15.3693C26.1705 15.3693 26.6875 15.5099 27.1307 15.7912C27.5767 16.0724 27.9233 16.4673 28.1705 16.9759C28.4205 17.4844 28.5455 18.0795 28.5455 18.7614C28.5455 19.4375 28.4205 20.0284 28.1705 20.5341C27.9233 21.0398 27.5767 21.4332 27.1307 21.7145C26.6875 21.9957 26.1705 22.1364 25.5795 22.1364ZM25.5795 21.233C26.0284 21.233 26.3977 21.1179 26.6875 20.8878C26.9773 20.6577 27.1918 20.3551 27.331 19.9801C27.4702 19.6051 27.5398 19.1989 27.5398 18.7614C27.5398 18.3239 27.4702 17.9162 27.331 17.5384C27.1918 17.1605 26.9773 16.8551 26.6875 16.6222C26.3977 16.3892 26.0284 16.2727 25.5795 16.2727C25.1307 16.2727 24.7614 16.3892 24.4716 16.6222C24.1818 16.8551 23.9673 17.1605 23.8281 17.5384C23.6889 17.9162 23.6193 18.3239 23.6193 18.7614C23.6193 19.1989 23.6889 19.6051 23.8281 19.9801C23.9673 20.3551 24.1818 20.6577 24.4716 20.8878C24.7614 21.1179 25.1307 21.233 25.5795 21.233Z"
      fill={color}
    />
    <path
      d="M9.83378 19.5041C4.68681 19.5041 0.499957 15.2579 0.499958 10.002C0.499958 4.74618 4.68681 0.499999 9.83378 0.5C14.9807 0.5 19.1676 4.74618 19.1676 10.002C19.1676 15.2579 14.9807 19.5041 9.83378 19.5041Z"
      stroke={color}
    />
  </svg>
);

export const DiamondSvg = ({ color }: SvgIconProp) => (
  <svg
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6108 22.7067C22.0653 22.7067 21.5838 22.5689 21.1662 22.2933C20.7486 22.0149 20.4219 21.6229 20.1861 21.1172C19.9503 20.6087 19.8324 20.0078 19.8324 19.3146C19.8324 18.6271 19.9503 18.0305 20.1861 17.5249C20.4219 17.0192 20.75 16.6286 21.1705 16.353C21.5909 16.0774 22.0767 15.9396 22.6278 15.9396C23.054 15.9396 23.3906 16.0107 23.6378 16.1527C23.8878 16.2919 24.0781 16.451 24.2088 16.63C24.3423 16.8061 24.446 16.951 24.5199 17.0646H24.6051V13.843H25.6108V22.5703H24.6392V21.5646H24.5199C24.446 21.6839 24.3409 21.8345 24.2045 22.0163C24.0682 22.1953 23.8736 22.3558 23.6207 22.4979C23.3679 22.6371 23.0313 22.7067 22.6108 22.7067ZM22.7472 21.8033C23.1506 21.8033 23.4915 21.6982 23.7699 21.4879C24.0483 21.2749 24.2599 20.9808 24.4048 20.6058C24.5497 20.228 24.6222 19.7919 24.6222 19.2976C24.6222 18.8089 24.5511 18.3814 24.4091 18.0149C24.267 17.6456 24.0568 17.3587 23.7784 17.1541C23.5 16.9467 23.1563 16.843 22.7472 16.843C22.321 16.843 21.9659 16.9524 21.6818 17.1712C21.4006 17.3871 21.1889 17.6811 21.0469 18.0533C20.9077 18.4226 20.8381 18.8374 20.8381 19.2976C20.8381 19.7635 20.9091 20.1868 21.0511 20.5675C21.196 20.9453 21.4091 21.2464 21.6903 21.4709C21.9744 21.6925 22.3267 21.8033 22.7472 21.8033Z"
      fill={color}
    />
    <rect
      x="20.5336"
      y="10.6203"
      width="14.0194"
      height="14.0194"
      rx="0.5"
      transform="rotate(135 20.5336 10.6203)"
      stroke={color}
    />
  </svg>
);

export const TextSvg = ({ color }: SvgIconProp) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.767 15.4545V16.3068H18.375V15.4545H21.767ZM19.3636 13.8864H20.3693V20.125C20.3693 20.4091 20.4105 20.6222 20.4929 20.7642C20.5781 20.9034 20.6861 20.9972 20.8168 21.0455C20.9503 21.0909 21.0909 21.1136 21.2386 21.1136C21.3494 21.1136 21.4403 21.108 21.5114 21.0966C21.5824 21.0824 21.6392 21.071 21.6818 21.0625L21.8864 21.9659C21.8182 21.9915 21.723 22.017 21.6009 22.0426C21.4787 22.071 21.3239 22.0852 21.1364 22.0852C20.8523 22.0852 20.5739 22.0241 20.3011 21.902C20.0313 21.7798 19.8068 21.5938 19.6278 21.3438C19.4517 21.0938 19.3636 20.7784 19.3636 20.3977V13.8864Z"
      fill={color}
    />
    <path
      d="M10.5 1L2 1C1.44772 1 1 1.44772 1 2L1 3.25M10.5 1L19 1C19.5523 1 20 1.44772 20 2V3.25M10.5 1L10.5 19"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LineSvg = ({ color }: SvgIconProp) => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4111 22.5493C20.9963 22.5493 20.6199 22.4712 20.2818 22.315C19.9438 22.1559 19.6753 21.9272 19.4764 21.6289C19.2776 21.3278 19.1782 20.9641 19.1782 20.538C19.1782 20.163 19.252 19.859 19.3997 19.626C19.5475 19.3903 19.7449 19.2056 19.9921 19.0721C20.2392 18.9385 20.512 18.8391 20.8103 18.7738C21.1114 18.7056 21.4139 18.6516 21.7179 18.6118C22.1157 18.5607 22.4381 18.5224 22.6853 18.4968C22.9353 18.4684 23.1171 18.4215 23.2307 18.3562C23.3472 18.2908 23.4054 18.1772 23.4054 18.0153V17.9812C23.4054 17.5607 23.2904 17.234 23.0603 17.001C22.833 16.7681 22.4878 16.6516 22.0247 16.6516C21.5446 16.6516 21.1682 16.7567 20.8955 16.967C20.6228 17.1772 20.431 17.4016 20.3202 17.6403L19.3657 17.2993C19.5361 16.9016 19.7634 16.592 20.0475 16.3704C20.3344 16.1459 20.6469 15.9897 20.985 15.9016C21.3259 15.8107 21.6611 15.7653 21.9907 15.7653C22.2009 15.7653 22.4424 15.7908 22.7151 15.842C22.9907 15.8903 23.2563 15.9911 23.512 16.1445C23.7705 16.2979 23.985 16.5295 24.1554 16.8391C24.3259 17.1488 24.4111 17.5635 24.4111 18.0834V22.3959H23.4054V21.5096H23.3543C23.2861 21.6516 23.1725 21.8036 23.0134 21.9655C22.8543 22.1275 22.6426 22.2653 22.3784 22.3789C22.1142 22.4925 21.7918 22.5493 21.4111 22.5493ZM21.5645 21.6459C21.9622 21.6459 22.2975 21.5678 22.5702 21.4116C22.8458 21.2553 23.0532 21.0536 23.1924 20.8064C23.3344 20.5593 23.4054 20.2993 23.4054 20.0266V19.1062C23.3628 19.1573 23.2691 19.2042 23.1242 19.2468C22.9821 19.2866 22.8174 19.3221 22.6299 19.3533C22.4452 19.3817 22.2648 19.4073 22.0887 19.43C21.9154 19.4499 21.7747 19.467 21.6668 19.4812C21.4054 19.5153 21.1611 19.5707 20.9338 19.6474C20.7094 19.7212 20.5276 19.8334 20.3884 19.984C20.252 20.1317 20.1838 20.3334 20.1838 20.5891C20.1838 20.9385 20.3131 21.2028 20.5716 21.3817C20.833 21.5579 21.1639 21.6459 21.5645 21.6459Z"
      fill={color}
    />
    <path
      d="M1.00001 19L16 1M16 1L10.5416 2.17428M16 1L15.9 6.35993"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
